declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: (string | number | Record<string, unknown>)[]) => void;
  }
}

const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID ?? "";

export function isAnalyticsEnabled(): boolean {
  return typeof window !== "undefined" && typeof window.gtag === "function" && GA_ID.length > 0;
}

export function pageview(path: string, title?: string) {
  if (!isAnalyticsEnabled()) return;
  window.gtag!("event", "page_view", {
    page_path: path,
    page_title: title ?? document.title,
    page_location: window.location.href,
    send_to: GA_ID,
  });
}

export function event(name: string, params?: Record<string, string | number | boolean>) {
  if (!isAnalyticsEnabled()) return;
  window.gtag!("event", name, { send_to: GA_ID, ...params });
}

export function scroll(depth: 50 | 90) {
  event(`scroll_${depth}`, { percent: depth });
}

export function viewItem(itemName: string, itemType: string) {
  event("view_item", { item_name: itemName, item_type: itemType });
}

export function clickCta(label: string, location: string) {
  event("cta_click", { cta_label: label, cta_location: location });
}

export function beginCheckout(plan: string) {
  event("begin_checkout", { plan });
}

export function submitForm(formName: string) {
  event("form_submit", { form_name: formName });
}
